export const NETWORK_ERROR_MODAL_TITLE = 'Too many bananas!';
export const NETWORK_ERROR_MODAL_TEXT = `
  Something went wrong. If this error persists, please contact support@mobilemonkey.com
`;

export const CONNECTVITIY_ERROR_MODAL_TITLE =
  'We are having trouble connecting to our servers!';
export const CONNECTVITIY_ERROR_MODAL_TEXT = `
  Please ensure that your internet connection is working correctly and try again.
`;
